/* eslint-disable */
import React,{ Component } from "react";
import PropTypes from "prop-types";
import Navigate from "../../../shared/navigation/navigate";
import Modal from "react-modal";
import { overlayModalStyle } from "../../helpers/ui-helper";
import { routesContext } from "../../../shared/routes/routes-context";
import GolferApi from "../../../services/golfer-api";

class JoinChallengeModal extends Component {
  static contextType = routesContext;

  constructor(props) {
    super(props);
    this.state = {
      doNotAskAgain: false,
    };
  }

  componentDidMount = () => Modal.setAppElement(this.props.appElementName);

  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      doNotAskAgain: !prevState.doNotAskAgain,
    }));
  };

  handleNoThanks = () => {
    if (this.state.doNotAskAgain) {
      GolferApi.challengeDisplayPreference(
        this.props.golferId,
        this.props.challengeId,
        false // display challenge = false
      ).finally(() => {
        this.props.onCloseModal();
      });
    } else {
      this.props.onCloseModal();
    }
  };

  render() {
    const { isOpen } = this.props;
    const { doNotAskAgain } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        style={overlayModalStyle}
        className="challenge-modal-dialog"
        contentLabel="Join Challenge Modal"
      >
        <div className="challenge-modal-content">
          <button
            className="challenge-modal_close"
            onClick={this.handleNoThanks}
            aria-label="Close"
          >
            ✕
          </button>
          <div className="challenge-modal-body">
            <div
              style={{
                width: "50%",
                backgroundColor: "#E9F7EC",
                color: "#27AE60",
                fontSize: "14px",
                fontWeight: "600",
                textAlign: "center",
                padding: "5px 10px",
                borderRadius: "15px",
                display: "inline-block",
                margin: "auto",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              {this.props.upcomingChallenge
                ? "Challenge Coming Soon"
                : "● Live Challenge"}
            </div>

            <h3
              style={{
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              {this.props.upcomingChallenge
                ? `Join the ${this.props.name}`
                : `Post this round to the ${this.props.name}`}
            </h3>
            <p
              style={{
                fontSize: "16px",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              Use your Handicap Index® to play in a virtual net competition
              against golfers of all skill levels
            </p>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                paddingLeft: "70px",
                margin: "20px auto",
                width: "400px",
                textAlign: "left",
                fontSize: "18px",
                lineHeight: "1.8",
              }}
            >
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  className="usga-calendar_2"
                  style={{ marginRight: "10px" }}
                />
                {this.props.challengeDate}
              </li>
              <div className="separator-horizontal" />
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="golfcup" style={{ marginRight: "10px" }} />
                Post 3+ scores to qualify
              </li>
              <div className="separator-horizontal" />
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className="usga-medal" style={{ marginRight: "10px" }} />
                <div className="text-content">
                  <div>Your top 3 net scores count</div>
                  <div className="subtext">toward a virtual leaderboard</div>
                </div>
              </li>
            </ul>

            <div className="actions centered" style={{ marginTop: "20px" }}>
              <button
                className="btn fill blue"
                onClick={this.props.onConfirmModal}
                style={{
                  width: "100%",
                  maxWidth: "70%",
                  padding: "10px",
                  fontSize: "18px",
                  marginBottom: "10px",
                  height: "45px",
                }}
              >
                JOIN CHALLENGE
              </button>
              <button
                className="btn outline blue"
                onClick={() =>
                  Navigate.toPath("/challenges/" + this.props.challengeId)
                }
                style={{
                  width: "100%",
                  maxWidth: "70%",
                  padding: "10px",
                  fontSize: "18px",
                  marginBottom: "20px",
                  borderRadius: "20px",
                  height: "45px",
                }}
              >
                LEARN MORE
              </button>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  maxWidth: "70%",
                  width: "100%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    style={{ width: "18px", height: "18px" }}
                    type="checkbox"
                    name="do-not-ask-again"
                    id="do-not-ask-again"
                    checked={doNotAskAgain}
                    onChange={this.handleCheckboxChange}
                  />
                  <label
                    htmlFor="do-not-ask-again"
                    style={{ marginLeft: "8px", marginTop: "8px" }}
                  >
                    Don't ask me again
                  </label>
                </div>

                <button
                  className="white color-focus"
                  onClick={this.handleNoThanks}
                  style={{
                    textAlign: "center",
                    fontSize: "16px",
                    color: "#00365F",
                    fontWeight: "550",
                    background: "white",
                    border: "none",
                    cursor: "pointer",
                    letterSpacing: "1.5px",
                  }}
                >
                  NO THANKS
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

JoinChallengeModal.defaultProps={
  appElementName: "body",
  onCloseModal: () => { },
  onConfirmModal: () => { },
  onLearnMore: () => { },
};

JoinChallengeModal.propTypes={
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func,
  onConfirmModal: PropTypes.func,
  onLearnMore: PropTypes.func,
};

export default JoinChallengeModal;
